import { Table } from './table.model';

export interface Order {

  id?: string;
  companyId: string;
  siteId: string;
  bookingId: string;
  createDate: Date;
  dt: Date | null;
  table: Table;
  userId: string;
  orderLines: OrderLine[];
  status: string;
  paymentStatus: boolean;
  discount?: number;
  deliveryCost?: number;
}

export class Order implements Order {
  constructor(
    public orderLines: OrderLine[] = [],
  ) { }
}

export class OrderLine {
  constructor(

    public id: string,
    public heading: string,
    public detail: string,
    public cost: number,
    public prodId: string,
    public quantity: number,
    public kCal: number,
    public image: any,
    public salesStyle: any,
    public minOrderLevel: number | 1


  ) { }
}
